import { Link, useLocation } from "react-router-dom";
import RoosterLogo from "@/components/RoosterLogo";
import { Mail } from "lucide-react";

export default function CheckEmailPage() {
  const { state } = useLocation();
  const email = state?.email || "your inbox";
  return (
    <div className="min-h-screen bg-[#F9F9F9]">
      <header className="border-b border-black/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <RoosterLogo size={36} />
            <div className="font-display text-2xl font-black tracking-tighter">Weathervane</div>
          </Link>
        </div>
      </header>
      <section className="max-w-2xl mx-auto px-6 lg:px-12 py-24">
        <div className="border border-black bg-white p-10" data-testid="check-email-card">
          <div className="inline-flex items-center justify-center w-12 h-12 border border-black bg-[#FFD600] mb-6">
            <Mail className="w-6 h-6" />
          </div>
          <div className="ticker-label mb-3">Almost there</div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter">Check your inbox.</h1>
          <p className="mt-6 text-neutral-700 leading-relaxed">
            We just emailed a confirmation link to <span className="font-semibold">{email}</span>.
            Click it to activate your daily forecast. No daily forecasts will be sent until you confirm.
          </p>
          <p className="mt-3 text-sm text-neutral-500">
            Don&rsquo;t see it? Check spam/promotions, or wait a minute — new domains occasionally take a moment.
          </p>
        </div>
      </section>
    </div>
  );
}
